export const getSearchURL = (configName: string, value: string) => {
  if (!configName || !value) {
    return '#';
  }

  const url = `${window.appContext}/page/search#searchQuery=`;

  const prefix = configName.split(':')[0];

  const localName = prefix.replace('mmAspect', '');

  const query = encodeURIComponent(
    `(TYPE:'ctbd:baseDoc') AND ASPECT:'${prefix}:${localName}' AND ${configName}:'${value}'`
  );

  return url + query;
};
